export const CAMPAIGNS_ROUTE = '/campaigns'
export const CAMPAIGN_DETAILS_ROUTE = `${CAMPAIGNS_ROUTE}/:themeId`
export const LOGIN_ROUTE = '/login'
export const SIGNUP_ROUTE = '/signup'
export const KEYWORDS_ROUTE = '/keywords'
export const KEYWORD_DETAILS_ROUTE = `${KEYWORDS_ROUTE}/:themeId/:keywordName`
export const HOME_ROUTE = '/home'
export const PROJECTS_ROUTE = '/projects'
export const PROJECT_DETAILS_ROUTE = `${PROJECTS_ROUTE}/:projectId`
export const INBOX_ANALYSIS_ROUTE = '/inbox-analysis'
export const INBOX_ANALYSIS_DETAIL_ROUTE = `${INBOX_ANALYSIS_ROUTE}/:pageId`
export const CONTENT_ANALYSIS_ROUTE = '/content-analysis'
export const CONTENT_ANALYSIS_DETAIL_ROUTE = `${CONTENT_ANALYSIS_ROUTE}/:analysisId`
export const REVIEW_ANALYSIS_ROUTE = '/review-analysis'
export const REVIEW_ANALYSIS_CAMPAIGN_ROUTE = `${REVIEW_ANALYSIS_ROUTE}/:campaignId`
export const REVIEW_ANALYSIS_BRAND_LEVEL_WIDGETS_ROUTE = `${REVIEW_ANALYSIS_CAMPAIGN_ROUTE}/brand-level-widgets`
export const REVIEW_ANALYSIS_PLATFORM_DETAILS_ROUTE = `${REVIEW_ANALYSIS_CAMPAIGN_ROUTE}/platform/:platformId`
export const REVIEW_ANALYSIS_FACILITY_DETAILS_ROUTE = `${REVIEW_ANALYSIS_CAMPAIGN_ROUTE}/facility/:facilityId`
export const REVIEW_ANALYSIS_CONNECT_ROUTE = `${REVIEW_ANALYSIS_CAMPAIGN_ROUTE}/connect`
export const SETTINGS_ROUTE = '/settings'
export const SETTINGS_ACCOUNT_ROUTE = '/settings/account'
export const SETTINGS_BILLING_ROUTE = '/settings/billing'
export const SETTINGS_SUBSCRIPTION_ROUTE = '/settings/subscription'
export const SETTINGS_COMPANY_PROFILE_ROUTE = '/settings/company-profile'
// Stripe Checkout redirect targets (success_url / cancel_url on the backend).
export const SUBSCRIPTION_SUCCESS_ROUTE = '/subscription/success'
export const SUBSCRIPTION_CANCEL_ROUTE = '/subscription/cancel'
export const NEW_CAMPAIGN_ROUTE = '/new-campaign'
export const UPDATE_CAMPAIGN_BASE_ROUTE = '/update-campaign'
export const UPDATE_CAMPAIGN_ROUTE = `${UPDATE_CAMPAIGN_BASE_ROUTE}/:id`
export const THREADS_ROUTE = '/threads'
export const AI_ASSISTANT_ROUTE = '/ai-assistant'
export const AI_LISTENING_ROUTE = '/ai-listening'
export const AI_LISTENING_BRAND_ROUTE = `${AI_LISTENING_ROUTE}/brand`
export const AI_LISTENING_BRAND_NEW_ROUTE = `${AI_LISTENING_BRAND_ROUTE}/new`
export const AI_LISTENING_BRAND_PROFILE_ROUTE = `${AI_LISTENING_BRAND_ROUTE}/:profileId`
export const AI_LISTENING_COMPETITORS_ROUTE = `${AI_LISTENING_BRAND_PROFILE_ROUTE}/competitors`
export const AI_LISTENING_COMPETITOR_NEW_ROUTE = `${AI_LISTENING_COMPETITORS_ROUTE}/new`
export const AI_LISTENING_COMPETITOR_ROUTE = `${AI_LISTENING_COMPETITORS_ROUTE}/:competitorId`
export const AI_LISTENING_PROMPTS_ROUTE = `${AI_LISTENING_ROUTE}/prompts`
export const AI_LISTENING_PROMPT_DETAILS_ROUTE = `${AI_LISTENING_PROMPTS_ROUTE}/:promptId`
// Pre-redesign addresses, kept as redirects for bookmarks and report links.
export const AI_LISTENING_NEW_CAMPAIGN_ROUTE = `${AI_LISTENING_ROUTE}/new`
export const AI_LISTENING_CAMPAIGN_DETAIL_ROUTE = `${AI_LISTENING_ROUTE}/campaign/:campaignId`
export const AI_LISTENING_DETAILS_ROUTE = `${AI_LISTENING_ROUTE}/details/:campaignId`
export const SMART_INSIGHTS_TEST_ROUTE = '/smart-insights-test'
export const AD_ANALYSIS_ROUTE = '/ad-analysis'
export const AD_ANALYSIS_OVERVIEW_ROUTE = `${AD_ANALYSIS_ROUTE}/overview`
export const AD_ANALYSIS_LIBRARY_ROUTE = `${AD_ANALYSIS_ROUTE}/ad-library`
export const AD_ANALYSIS_LIBRARY_DETAIL_ROUTE = `${AD_ANALYSIS_LIBRARY_ROUTE}/:pageId`
export const AD_ANALYSIS_PERFORMANCE_ROUTE = `${AD_ANALYSIS_ROUTE}/ad-performance`

export const CUSTOM_REPORTING_ROUTE = '/custom-reporting'
